import service from './http'
import serve from "@/utils/serve";
import mountQuery from "@/utils/mountQuery";
import Idea, {AccessKind, PropertyAccessKind} from "@/types/Idea";
import IdeaProperty from "@/types/IdeaProperty";
import {FormulaCheck, FormulaVocabulary} from "@/types/FormulaVocabulary";
type SystemAlias = { systemAlias: string }
type SystemIdeaAlias = { systemAlias: string, ideaAlias: string }
type Options = { options: string[] };
const defaultOptions: Options = {options: []}

type SystemIdeaPropertyAlias = { systemAlias: string, ideaAlias: string, propertyAlias: string }


class IdeaPropertyService {

    async add({systemAlias, ideaAlias}: SystemIdeaAlias, property: IdeaProperty) {
        return await serve(async () => await service.post(`systems/${systemAlias}/ideas/${ideaAlias}/properties`, property))
    }

    async list({systemAlias, ideaAlias}: SystemIdeaAlias, idea: IdeaProperty) {
        return await serve(async () => await service.get(`systems/${systemAlias}/ideas/${ideaAlias}/properties`)) as IdeaProperty[]
    }

    async get({systemAlias, ideaAlias, propertyAlias}: SystemIdeaPropertyAlias) {
        return await serve(async () => await service.get(`systems/${systemAlias}/ideas/${ideaAlias}/properties/${propertyAlias}`)) as IdeaProperty
    }

    async update({systemAlias, ideaAlias, propertyAlias}: SystemIdeaPropertyAlias, changes: any) {
        return await serve(async () => await service.patch(`systems/${systemAlias}/ideas/${ideaAlias}/properties/${propertyAlias}`, changes))
    }

    async delete({systemAlias, ideaAlias, propertyAlias}: SystemIdeaPropertyAlias) {
        return await serve(async () => await service.delete(`systems/${systemAlias}/ideas/${ideaAlias}/properties/${propertyAlias}`))
    }

    /** O que o editor de fórmula sugere nesta coleção. */
    async formulaVocabulary({systemAlias, ideaAlias}: SystemIdeaAlias) {
        return await serve(async () => await service.get(`systems/${systemAlias}/ideas/${ideaAlias}/formula/vocabulary`)) as FormulaVocabulary
    }

    /**
     * A fórmula em edição conferida como o salvar a conferiria, sem gravar. `property` é o
     * rascunho do atributo (tipo, múltiplo, fórmula); `current`, o alias dele quando é edição.
     */
    /**
     * `rule`: o índice da regra a conferir no rascunho; `optionFilter`, as "Opções permitidas" dele —
     * sem os dois, a fórmula do calculado.
     */
    /**
     * A fórmula em edição conferida como o salvar a conferiria. A de um atributo (`property`, e `rule`
     * ou `optionFilter`), ou uma de acesso da coleção (`access`, com o texto em `source`).
     */
    async checkFormula({systemAlias, ideaAlias}: SystemIdeaAlias,
                       body: {property: Partial<IdeaProperty>, current?: string, rule?: number, optionFilter?: boolean,
                           fieldAccess?: PropertyAccessKind, defaultFormula?: boolean}
                           | {access: AccessKind, source: string}) {
        return await serve(async () => await service.post(`systems/${systemAlias}/ideas/${ideaAlias}/formula/check`, body)) as FormulaCheck
    }
}

export default IdeaPropertyService